module.exports = __webpack_public_path__ + "static/media/whoweare.b072e233.png";